import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import ProcedureManual_Form from "./procedureManual_Form/ProcedureManual_Form";
import ProcedureManual_table from "./procedureManual_table/ProcedureManual_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/structural_requirement/management_data/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function ProcedureManual() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const management_data = useSelector((state) => state.management_data);
  // console.log("management_datamanagement_datamanagement_data",management_data)

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        management_data_id: 2,
        page,
        per_page: management_data.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.management_data.List);
  const haveAddPermission = permissions?.includes(FixIDS.procedure_manual.Add);

  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Procedure Manual" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              The Procedure Manual provides detailed step-by-step instructions
              for all laboratory activities, ensuring consistency, accuracy, and
              compliance with quality standards. It guides staff in performing
              tests, handling equipment, maintaining records, and managing files
              systematically to achieve reliable and traceable results.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          {haveAddPermission && (
            <ProcedureManual_Form fetchCustomers={fetchCustomers} />
          )}
        </div>

        <div className="imperiality_table_div">
          {haveReadPermission && (
            <ProcedureManual_table
              data={management_data}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              fetchCustomers={fetchCustomers}
            />
          )}
        </div>

        <div className="m-3">
          {/* <div className="add_another_holder">
          <div>
            <span>
              <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
            </span>
          </div>
        </div> */}
        </div>
      </section>
    </>
  );
}

export default ProcedureManual;
